// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__xfvCz","content":"Details_content__qmE8Y"};